import React from 'react';

import phone from '../../../../../../../images/phone.svg';
import { fullName } from '../../../../../common/helpers/users';
import MobileTooltip from '../../LocateDuplicates/components/MobileTooltip';

const Names = ({ duplicates, duplicateCellClass, selectAll, isMobileSurvivingCustomer }) => (
  <div className="c-table-card__row c-table-card__row--transparent">
    <div className="c-table-card__cell u-2/12" />
    <div className="c-table-card__cell u-3/12" />
    {
      duplicates.map((d, idx) => (
        <div className={duplicateCellClass}>
          {
            isMobileSurvivingCustomer && idx === 0 && (
              <span className="u-mr--">
                <MobileTooltip className="u-mr--" src={phone} style={{ width: '15px' }} alt="mobile" />
              </span>
            )
          }
          {fullName(d)}
          <button
            type="button"
            className="c-link-primary-dark u-ml- u-cursor-pointer c-btn--blank"
            data-idx={idx}
            onClick={selectAll}
            disabled={isMobileSurvivingCustomer}
          >
            (Select all)
          </button>
        </div>
      ))
    }
  </div>
);

export default Names;
